import axios from 'axios'

export const state = {
  currentProperty: null,
}

export const getters = {}

export const mutations = {
  SET_CURRENT_PROPERTY(state, newValue) {
    state.currentProperty = newValue
  },
}

export const actions = {
  fetchProperty({ commit, state }, { property }) {
    // Check if we already have a current property.
    const { currentProperty } = state
    if (currentProperty && currentProperty.permalink === property) {
      return Promise.resolve(currentProperty)
    }

    return axios.post('/api/v2/get_property', { property }).then((response) => {
      const { data } = response

      commit('SET_CURRENT_PROPERTY', data)

      return data
    })
  },
}
